var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-setting-input-box',{attrs:{"value":_vm.bindingKey,"input-class":"white","label":"bindingKey","hide-details":"","dense":"","outlined":""},on:{"change":_vm.changeBindingKey}})}
var staticRenderFns = []

export { render, staticRenderFns }